var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDownArrOn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "chevron-up"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector (Stroke)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.1985 6.07741C10.5239 5.75197 11.0516 5.75197 11.377 6.07741L17.2103 11.9107C17.5358 12.2362 17.5358 12.7638 17.2103 13.0893C16.8849 13.4147 16.3573 13.4147 16.0318 13.0893L10.7878 7.84518L5.54368 13.0893C5.21825 13.4147 4.69061 13.4147 4.36517 13.0893C4.03973 12.7638 4.03973 12.2362 4.36517 11.9107L10.1985 6.07741Z",
    fill: "#0E6AF4"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownArrOn);
export default __webpack_public_path__ + "static/media/down_arr_on.832bfa38fa5e3b5c15789bad32bc3065.svg";
export { ForwardRef as ReactComponent };